import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "18",
  viewBox: "0 0 14 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.556 0C.696 0 0 .732 0 1.636v14.728C0 17.268.696 18 1.556 18H3.11c.86 0 1.556-.732 1.556-1.636V1.636C4.667.732 3.97 0 3.11 0zm9.333 0c-.86 0-1.556.732-1.556 1.636v14.728c0 .904.696 1.636 1.556 1.636h1.555c.86 0 1.556-.732 1.556-1.636V1.636C14 .732 13.304 0 12.444 0z" }, null, -1)
  ])))
}
export default { render: render }